import { HawkSearchComponents, RelatedSearchesFacetComponentConfig, RelatedSearchesFacetComponentModel } from '@models';
import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './related-searches-facet.component.hbs';

export class RelatedSearchesFacetComponent extends BaseFacetComponent<RelatedSearchesFacetComponentConfig, RelatedSearchesFacetComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'related-searches-facet';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data?.values?.length;
    }

    protected override getContentModel(): RelatedSearchesFacetComponentModel {
        return {
            values: this.data!.values?.map((v) => v.title) ?? []
        };
    }

    protected bindChildElements(): void {
        super.bindChildElements();

        this.rootElement.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
